import { Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel } from "@material-ui/core";
import React, { useEffect } from 'react';
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import PaginatedTableActions from "src/components/Table/PaginatedTableActions";
import { onError } from "src/store/actions/popupActions";
import { INTERNAL_BILATERAL_CONTRACT_RESULTS_RETRIEVED, INTERNAL_BILATERAL_CONTRACTS_RESULTS_DIRECTION, INTERNAL_BILATERAL_CONTRACTS_RESULTS_ORDER_BY, INTERNAL_BILATERAL_CONTRACTS_RESULTS_PAGE_SIZE } from "src/store/InternalBilateral/InternalBilateralActionTypes";
import axios from "../../../axios/AxiosInterceptors";
import useStyles from "../../../Styles";

const ViewContracts = (props) => {

    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const results = useSelector(state => state.internalBilateral.contractResults);
    const pageSize = useSelector(state => state.internalBilateral.contractResultsPageSize);
    const direction = useSelector(state => state.internalBilateral.contractResultsDirection);
    const orderBy = useSelector(state => state.internalBilateral.contractResultsOrderBy);

    useEffect(() => {
        retrieveContracts(0, pageSize, orderBy, direction);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])

    const retrieveContracts = async (pageNumber, pageSize, orderBy, direction) => {
        let urlParams = { pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, direction: direction };
        await trackPromise(axios.get("/inschedule/v2/account/" + params.accountId + "/contract", { params: urlParams }).then(response => {
            dispatch({ type: INTERNAL_BILATERAL_CONTRACT_RESULTS_RETRIEVED, contractResults: response.data });
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const handleSort = (column) => {
        let sortDirection = column === orderBy && direction === 'asc' ? 'desc' : 'asc'
        dispatch({ type: INTERNAL_BILATERAL_CONTRACTS_RESULTS_DIRECTION, contractResultsDirection: sortDirection });
        dispatch({ type: INTERNAL_BILATERAL_CONTRACTS_RESULTS_ORDER_BY, contractResultsOrderBy: column });
        retrieveContracts(0, pageSize, column, sortDirection);
    }

    const handlePageChange = (pageNumber, pageSize) => {
        retrieveContracts(pageNumber, pageSize, orderBy, direction);
    }

    const calculateRowsPerPage = (rowsPerPage) => {
        if (!rowsPerPage) {
            return 10;
        }
        if (rowsPerPage <= 10) {
            return 10;
        }
        if (rowsPerPage <= 25) {
            return 25;
        }
        if (rowsPerPage <= 50) {
            return 50;
        }
        return rowsPerPage;
    }

    const handleRowsPerPageChange = (e) => {
        dispatch({ type: INTERNAL_BILATERAL_CONTRACTS_RESULTS_PAGE_SIZE, contractResultsPageSize: e.target.value });
        retrieveContracts(0, e.target.value, orderBy, direction);
    }

    return (
        <main className={classes.layout}>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <TableSortLabel active={orderBy === "contractId"} direction={orderBy === "contractId" ? direction : 'asc'}
                                    onClick={() => handleSort("contractId")}>
                                    Contract ID
                                    {orderBy === "contractId" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "contractName"} direction={orderBy === "contractName" ? direction : 'asc'}
                                    onClick={() => handleSort("contractName")}>
                                    Contract Name
                                    {orderBy === "contractName" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "startDate"} direction={orderBy === "startDate" ? direction : 'asc'}
                                    onClick={() => handleSort("startDate")}>
                                    Start Date
                                    {orderBy === "startDate" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "endDate"} direction={orderBy === "endDate" ? direction : 'asc'}
                                    onClick={() => handleSort("endDate")}>
                                    End Date
                                    {orderBy === "endDate" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "pendingStopDate"} direction={orderBy === "pendingStopDate" ? direction : 'asc'}
                                    onClick={() => handleSort("pendingStopDate")}>
                                    Pending Stop Date
                                    {orderBy === "pendingStopDate" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "sellerName"} direction={orderBy === "sellerName" ? direction : 'asc'}
                                    onClick={() => handleSort("sellerName")}>
                                    Seller Name
                                    {orderBy === "sellerName" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "buyerName"} direction={orderBy === "buyerName" ? direction : 'asc'}
                                    onClick={() => handleSort("buyerName")}>
                                    Buyer Name
                                    {orderBy === "buyerName" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "source"} direction={orderBy === "source" ? direction : 'asc'}
                                    onClick={() => handleSort("source")}>
                                    Source
                                    {orderBy === "source" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "sink"} direction={orderBy === "sink" ? direction : 'asc'}
                                    onClick={() => handleSort("sink")}>
                                    Sink
                                    {orderBy === "sink" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "serviceType"} direction={orderBy === "serviceType" ? direction : 'asc'}
                                    onClick={() => handleSort("serviceType")}>
                                    Service Type
                                    {orderBy === "serviceType" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results && results.results && results.results.length > 0 && results.results.map(r => {
                            return (
                                <TableRow key={r.id} onClick={() => history.push("/internal-bilaterals/account/" + r.accountId + "/contract/" + r.id)} className={classes.tableRow}>
                                    <TableCell>{r.contractId}</TableCell>
                                    <TableCell>{r.contractName}</TableCell>
                                    <TableCell>{r.startDate}</TableCell>
                                    <TableCell>{r.endDate}</TableCell>
                                    <TableCell>{r.pendingStopDate}</TableCell>
                                    <TableCell>{r.sellerName}</TableCell>
                                    <TableCell>{r.buyerName}</TableCell>
                                    <TableCell>{r.source}</TableCell>
                                    <TableCell>{r.sink}</TableCell>
                                    <TableCell>{r.serviceType}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination count={results.totalCount ? results.totalCount : 0} onPageChange={handlePageChange}
                                page={results.pageNumber ? results.pageNumber : 0}
                                rowsPerPage={calculateRowsPerPage(results.pageSize)} onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[10, 25, 50]} colSpan={10} ActionsComponent={PaginatedTableActions} />
                        </TableRow>
                    </TableFooter>
                </Table>

            </TableContainer>
        </main>
    )
}

export default ViewContracts;